export default "__VITE_ASSET__Cgch1yhy__"